<template>
    <div>
        <h1 v-if="landlineSubscriptions.length" class="font-weight-light text-center">Líneas Fijas</h1>
        <v-card class="my-2" v-for="landLine in landlineSubscriptions" :key="landLine.bundleId">
            <v-card-title>
                <h5 class="font-weight-light">{{ landLine.bundleName ? landLine.bundleName : landLine.tariffName }}</h5>
                <v-spacer></v-spacer>
                <v-btn depressed color="primary" class="font-weight-light">{{landLine.number}}</v-btn>
            </v-card-title>

            <v-card-text>
                <div class="d-flex justify-space-between align-center">
                    <div class="d-flex align-center">
                        <h5 class="font-weight-light">Estado</h5>
                        <v-icon
                            class="ml-2"
                            right
                            :small="$vuetify.breakpoint.smAndDown"
                            :color="landLine.status === 'ACTIVATED' ? 'green' : 'red'"
                        >
                            mdi-circle
                        </v-icon>
                    </div>
                    <div class="d-flex align-center">
                        <h5 class="font-weight-light">Principal</h5>
                        <v-icon
                            class="ml-2"
                            right
                            :small="$vuetify.breakpoint.smAndDown"
                            :color="landLine.isMainLine ? 'green' : 'red'"
                        >
                            mdi-circle
                        </v-icon>
                    </div>
                    <AgentUserInfo :expeditionUserInfo="landLine.expeditionUserInfo" />
                </div>

                <v-divider class="my-2"></v-divider>

                <AgentPromos class="d-flex flex-wrap justify-center" :selectedContractId="selectedContractId" :serviceID="landLine.id" serviceType="landlineSubscriptions" />
                
                <v-divider class="my-2"></v-divider>

                <AgentPenalties class="d-flex flex-wrap justify-center" :selectedContractId="selectedContractId" :serviceNumber="landLine.number" :types="['LANDLINE', 'FTTH']"/>
                
                <!-- <v-divider class="my-2"></v-divider>

                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Tarifa</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>ID:</strong> {{ landLine.tariffId }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Nombre:</strong> {{ landLine.tariffName }}</h5>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Llamada</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Desde:</strong> {{ formatDateYYYYMMDD(landLine.callConsumptionInfo.from) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Hasta:</strong> {{ formatDateYYYYMMDD(landLine.callConsumptionInfo.to) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Total:</strong> {{ landLine.callConsumptionInfo.totalUsage }}</h5>
                        </div>
                    </div>
                </div> -->

                <v-divider class="my-2"></v-divider>

                <h3 class="font-weight-light text-center">{{ landLine.tariffName }}</h3>
                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Sesión</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Activación:</strong> {{ formatDateYYYYMMDD(landLine.metadataInfo.activationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Desactivación:</strong> {{ formatDateYYYYMMDD(landLine.metadataInfo.deactivationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Instalación:</strong> {{ formatDateYYYYMMDD(landLine.metadataInfo.installationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Pre-Activación:</strong> {{ formatDateYYYYMMDD(landLine.metadataInfo.preActivationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Venta:</strong> {{ formatDateYYYYMMDD(landLine.metadataInfo.sellDate) }}</h5>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Portabilidad</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Operación:</strong> {{ formatDateYYYYMMDD(landLine.portabilityInfo.operationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Estado:</strong> {{ landLine.portabilityInfo.portabilityStatus }}</h5>
                        </div>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between align-center' : 'd-flex flex-column'">
                <v-btn
                    x-small
                    depressed
                    outlined
                    color="primary"
                    class="mb-2"
                    @click="agentContract(landLine.contractUrl.split('/').pop()); isOpen = true;"
                >
                    <v-icon small left>mdi-file-document</v-icon>
                    Ver Contrato
                </v-btn>
                <AgentUserInfo title="Información de Propietario" :expeditionUserInfo="landLine.ownerUserInfo" />
            </v-card-actions>

        </v-card>
    </div>
</template>

<script>
import AgentPromos from './AgentPromos.vue';
import AgentUserInfo from './AgentUserInfo.vue';
import { mapActions } from 'vuex';
import { formatDateYYYYMMDD } from '@/util/libUtil.js';
import AgentPenalties from './AgentPenalties.vue';

export default {
    data: () => ({
    }),
    components: {
        AgentUserInfo,
        AgentPromos,
        AgentPenalties,
    },
    props: {
        landlineSubscriptions: {
            type: Array,
        },
        selectedContractId: {
            type: String,
        },
    },
    methods: {
        formatDateYYYYMMDD,
        ...mapActions('agent', ['agentContract']),
    },

};
</script>
